import { render, staticRenderFns } from "./ApprovalDetailModal.vue?vue&type=template&id=76c350ae&scoped=true&lang=pug"
import script from "./ApprovalDetailModal.vue?vue&type=script&lang=js"
export * from "./ApprovalDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDetailModal.vue?vue&type=style&index=0&id=76c350ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c350ae",
  null
  
)

export default component.exports